import { ApiResultVoPollResponseVo } from '@schemas/non-auth'
import { createPrefetchQuery } from '@utils/createPrefetchQuery'
import { fetchAPI } from '@utils/http/apiRequest'

export type PollParticiapationResponse = CommonResponse<ApiResultVoPollResponseVo>

export interface PollParticiapationReqModel {
	pollIdx: string
	answerIdxs: Array<string>
	answer?: string
	nonMemberId?: string
}

const path = '/restapi/v1/post/contents/poll/participation'
const queryKeyString = (props?: PollParticiapationReqModel) =>
	['@template/contents/poll/particiapation', props] as const

const getQuery = async (
	props: PollParticiapationReqModel,
	cookieHeader?: string,
): Promise<ApiResultVoPollResponseVo> => {
	const { pollIdx, answerIdxs, answer, nonMemberId } = props
	const params = new URLSearchParams()
	if (pollIdx) params.append('pollIdx', pollIdx)
	if (answerIdxs) answerIdxs.map((answerIdx) => params.append('answerIdxs', String(answerIdx)))
	if (answer) params.append('answer', String(answer))
	if (nonMemberId) params.append('nonMemberId', String(nonMemberId))
	return fetchAPI({ path, params, method: 'POST', cookieHeader })
}

export const queryPollParticiapation = (
	props: PollParticiapationReqModel,
	cookieHeader?: string,
) => ({
	queryKey: queryKeyString(props),
	queryFn: () => getQuery(props, cookieHeader),
})

export const pollParticiapationMutationProps = (cookieHeader?: string) => ({
	mutationKey: queryKeyString(),
	mutationFn: (props: PollParticiapationReqModel) => getQuery(props, cookieHeader),
})

export const prefetchPollParticiapation = (
	props: PollParticiapationReqModel,
	cookieHeader?: string,
) => createPrefetchQuery(queryKeyString(props), () => getQuery(props, cookieHeader))
